import apiInst from '../api.js';
import axios from 'axios';
axios.defaults.headers.common['X-Source-App'] = 'OrderPortal';

class PackagingService {
  constructor() {
    console.log('Packaging Service inst');
  }
  
  getPackaging() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.get(`/packaging/${GLN}`);
  }
}



export default new PackagingService();
